module.exports = "<div class=\"mt-3 row diner_summary_header ut-diner-summary-header\">\n    <div class=\"col-1\">No.</div>\n    <div class=\"col-5\">Name</div>\n    <div class=\"col-3 text-left\">Items</div>\n    <div class=\"col-3 text-right\">Total</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/dinerSummaryHeader.html
// module id = 769
// module chunks = 0